import Vue from 'vue'

Vue.filter('Tagstext', function (text) {
    switch (text) {
        case "姓名":
            return "学者"
        case "单位":
            return "单位"
        case "研究领域":
            return "领域"
        default:
            break;
    }
});

Vue.filter('lengthOf18', (text) => {
    // let str = /^[A-Za-z0-9]{lens}/;
    let str = text
    if (str.length>18) {
        str=str.substring(0,18)+"...";
    }
    return str
})
Vue.filter('lengthOf25', (text, lens) => {
    // let str = /^[A-Za-z0-9]{lens}/;
    let str = text
    if (str.length>lens) {
        str=str.substring(0,lens)+"...";
    }
    return str
})


// WEBPACK FOOTER //
// ./src/filter/search.js